import React, { useState, useEffect } from 'react';

const AnimatedPost = () => {
  const [visibleLines, setVisibleLines] = useState(0);
  const totalLines = 12;

  useEffect(() => {
    const interval = setInterval(() => {
      setVisibleLines((prev) => {
        if (prev >= totalLines) {
          // Reset after a brief pause
          setTimeout(() => setVisibleLines(0), 1000);
          return prev;
        }
        return prev + 1;
      });
    }, 200);

    return () => clearInterval(interval);
  }, []);

  // Different widths for a more natural look
  const lineWidths = [
    'w-full', 'w-full', 'w-3/4',
    'w-full', 'w-full',
    'w-2/3',
    'w-full', 'w-full', 'w-5/6',
    'w-full', 'w-4/5', 'w-1/2'
  ];

  return (
    <div className="bg-white rounded-lg md:rounded-xl border border-gray-200 overflow-hidden max-w-2xl">
      {/* Header */}
      <div className="p-3 md:p-4 flex items-start gap-2 md:gap-3">
        {/* Profile Picture */}
        <div className="w-8 h-8 md:w-12 md:h-12 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 flex-shrink-0 flex items-center justify-center text-white font-semibold text-xs md:text-lg">
          <img alt="Ömer Öztok" src="/assets/profile-display-photo-7.jpeg" className="w-full h-full object-cover rounded-full" />
        </div>
        
        {/* Author Info */}
        <div className="flex-1 min-w-0">
          <h4 className="font-semibold text-gray-900 text-xs md:text-sm">Ömer Öztok</h4>
          <p className="text-[10px] md:text-xs text-gray-600 line-clamp-1">
          Co-Founder @ Lynkr
          </p>
        </div>
      </div>

      {/* Post Content */}
      <div className="px-3 md:px-4 pb-3 md:pb-4 space-y-1.5 md:space-y-2.5">
        {Array.from({ length: totalLines }).map((_, index) => (
          <div
            key={index}
            className={`h-2 md:h-3 bg-gray-200 rounded transition-all duration-300 ${
              lineWidths[index]
            } ${
              index < visibleLines 
                ? 'opacity-100 scale-100' 
                : 'opacity-0 scale-95'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default AnimatedPost;